// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-stream-wrapper[data-v-4d5756e9]{width:100%;height:100%;position:relative;z-index:0}.qrcode-stream-overlay[data-v-4d5756e9]{width:100%;height:100%;position:absolute;top:0;left:0}.qrcode-stream-camera[data-v-4d5756e9]{width:100%;height:100%;display:block;-o-object-fit:cover;object-fit:cover}.qrcode-stream-camera--hidden[data-v-4d5756e9]{visibility:hidden;position:absolute}", ""]);
// Exports
module.exports = exports;
